module.exports = __webpack_public_path__ + "img/data-4.484bd5ae.png";